import { ApiResponse, http } from '@config/api';

export async function fetchSpecialistDashboardData() {
	const response = await http.get<ApiResponse<any>>(`analytics`, 'specialist/');

	return response.data;
}

export async function fetchFarmerDashboardData() {
	const response = await http.get<ApiResponse<any>>(`analytics`, 'farmer/');

	return response.data;
}
